
        var result = require("!!../../../../node_modules/css-loader/index.js!./account.details.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/account.management/account.details.component.css
// module id = 1115
// module chunks = 0